(function () {
  const translations = {
    es: {
      saleEndsSoon: 'La oferta termina pronto',
      days: 'Días',
      hours: 'Horas',
      mins: 'Min',
      secs: 'Seg',
    },

    it: {
      saleEndsSoon: 'La vendita termina presto',
      days: 'Giorni',
      hours: 'Ore',
      mins: 'Min',
      secs: 'Sec',
    },

    cs: {
      saleEndsSoon: 'Akce brzy končí',
      days: 'Dny',
      hours: 'Hodiny',
      mins: 'Min',
      secs: 'Sek',
    },

    pl: {
      saleEndsSoon: 'Wyprzedaż wkrótce się kończy',
      days: 'Dni',
      hours: 'Godziny',
      mins: 'Min',
      secs: 'Sek',
    },

    sk: {
      saleEndsSoon: 'Akcia sa čoskoro končí',
      days: 'Dni',
      hours: 'Hodiny',
      mins: 'Min',
      secs: 'Sek',
    },
  };

  function getLocale() {
    const locale = window.location.pathname.split('/')[1]?.toLowerCase();

    return translations[locale] ? locale : null;
  }

  function getLabel(numberEl) {
    if (!numberEl?.parentElement) {
      return null;
    }

    const spans = numberEl.parentElement.querySelectorAll(
      `span:not(.${numberEl.className})`
    );

    return spans.length > 0 ? spans[spans.length - 1] : null;
  }

  function translateCountdown() {
    const locale = getLocale();

    if (!locale) {
      return;
    }

    const translation = translations[locale];
    const countdown = document.querySelector('#countdown');

    if (!countdown) {
      return;
    }

    // Translate heading
    const heading = countdown.querySelector('.timer-store-front > div:first-child');

    if (heading && heading.textContent.trim() === 'Sale ends soon') {
      heading.textContent = translation.saleEndsSoon;
    }

    // Translate labels only
    const days = countdown.querySelector('.days');
    const hours = countdown.querySelector('.hours');
    const minutes = countdown.querySelector('.minutes');
    const seconds = countdown.querySelector('.seconds');

    if (days) {
      const label = getLabel(days);
      if (label && label.textContent.trim() === 'Days') {
        label.textContent = translation.days;
      }
    }

    if (hours) {
      const label = getLabel(hours);
      if (label && label.textContent.trim() === 'Hours') {
        label.textContent = translation.hours;
      }
    }

    if (minutes) {
      const label = getLabel(minutes);
      if (label && label.textContent.trim() === 'Mins') {
        label.textContent = translation.mins;
      }
    }

    if (seconds) {
      const label = getLabel(seconds);
      if (label && label.textContent.trim() === 'Secs') {
        label.textContent = translation.secs;
      }
    }
  }

  // Check immediately in case the widget already exists.
  translateCountdown();

  const observer = new MutationObserver(function () {
    translateCountdown();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
